export const spacing = {
  Radius: {
    none: {
      $type: "dimension",
      $value: "0px",
    },
    xxs: {
      $type: "dimension",
      $value: "2px",
    },
    xs: {
      $type: "dimension",
      $value: "4px",
    },
    sm: {
      $type: "dimension",
      $value: "6px",
    },
    md: {
      $type: "dimension",
      $value: "8px",
    },
    lg: {
      $type: "dimension",
      $value: "10px",
    },
    xl: {
      $type: "dimension",
      $value: "12px",
    },
    "2xl": {
      $type: "dimension",
      $value: "16px",
    },
    "3xl": {
      $type: "dimension",
      $value: "20px",
    },
    "4xl": {
      $type: "dimension",
      $value: "24px",
    },
    full: {
      $type: "dimension",
      $value: "9999px",
    },
  },
  Spacing: {
    none: {
      $type: "dimension",
      $value: "0px",
    },
    xxs: {
      $type: "dimension",
      $value: "2px",
    },
    xs: {
      $type: "dimension",
      $value: "4px",
    },
    sm: {
      $type: "dimension",
      $value: "6px",
    },
    md: {
      $type: "dimension",
      $value: "8px",
    },
    lg: {
      $type: "dimension",
      $value: "12px",
    },
    xl: {
      $type: "dimension",
      $value: "16px",
    },
    "2xl": {
      $type: "dimension",
      $value: "20px",
    },
    "3xl": {
      $type: "dimension",
      $value: "24px",
    },
    "4xl": {
      $type: "dimension",
      $value: "32px",
    },
    "5xl": {
      $type: "dimension",
      $value: "40px",
    },
    "6xl": {
      $type: "dimension",
      $value: "48px",
    },
    "7xl": {
      $type: "dimension",
      $value: "64px",
    },
    "8xl": {
      $type: "dimension",
      $value: "80px",
    },
    "9xl": {
      $type: "dimension",
      $value: "96px",
    },
    "10xl": {
      $type: "dimension",
      $value: "128px",
    },
    "11xl": {
      $type: "dimension",
      $value: "160px",
    },
  },
  Width: {
    xxs: {
      $type: "dimension",
      $value: "320px",
    },
    xs: {
      $type: "dimension",
      $value: "384px",
    },
    sm: {
      $type: "dimension",
      $value: "480px",
    },
    md: {
      $type: "dimension",
      $value: "560px",
    },
    lg: {
      $type: "dimension",
      $value: "640px",
    },
    xl: {
      $type: "dimension",
      $value: "768px",
    },
    "2xl": {
      $type: "dimension",
      $value: "1024px",
    },
    "3xl": {
      $type: "dimension",
      $value: "1280px",
    },
    "4xl": {
      $type: "dimension",
      $value: "1440px",
    },
    "5xl": {
      $type: "dimension",
      $value: "1600px",
    },
    "6xl": {
      $type: "dimension",
      $value: "1920px",
    },
  },
};
